import React, { PropsWithChildren } from 'react';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Box } from '@mui/material';
import { SingleRouteInfo } from '../types/routes';
import { BasicLink } from './BasicLink';

export type SingleViewLinkProps = {
  keys: { [s: string]: number | string };
  singlePageRoute: SingleRouteInfo;
  openInNewTab?: boolean;
};

export const SingleViewLink = ({
  keys,
  children,
  singlePageRoute,
  openInNewTab,
}: PropsWithChildren<SingleViewLinkProps>) => {
  const content = children ?? Object.values(keys)[0];
  const path = singlePageRoute.resolvePath(keys);

  if (!openInNewTab) return <BasicLink to={path}>{content}</BasicLink>;

  return (
    <BasicLink external href={`#${path}`} target="_blank" rel="noopener noreferrer">
      <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
        {content}
        <OpenInNewIcon sx={{ fontSize: '16px' }} />
      </Box>
    </BasicLink>
  );
};
